export const USER_PROFILE_TAB_POSTS_CREATED_BY_FILTER_KEY = 'created_by'

export const USER_PROFILE_TAB_POSTS_QA_NAME = 'userProfileTabPosts'
